(function($) {
    'use strict';

    let windowWidth = $(window).outerWidth();

    $(document.body).on('click', '.toggle-sub-menu', function() {
        $('body').removeClass('lang-open');
        $('.lang-wrp').removeClass('active');
        if( windowWidth > 767 ) {
            if ( $(this).hasClass('active') ) {
                $(this).removeClass('active');
                $(this).next().removeClass('active');
            } else {
                $('.toggle-sub-menu').removeClass('active');
                $('.sub-menu-wrapper').removeClass('active');
                $(this).addClass('active');
                $(this).next().addClass('active');
            }
        } else {
            $(this).toggleClass('active');
            $(this).next().slideToggle('active');
        }
    });

    $('body').click(function(){
        $('.toggle-sub-menu').removeClass('active');
        $('.sub-menu-wrapper').removeClass('active');
    });

    $(document.body).on('click', '.flyout', function(event) {
        event.stopPropagation();
    });

}(jQuery));